import React, { useState, useEffect } from "react";
import { Typography, Button, Box } from "@mui/material";
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import RefreshIcon from '@mui/icons-material/Refresh';
import NumberFormat from "react-number-format";
import { obtenerPresupuestosTotal } from "../../actions/PresupuestosAction";

export default function PresupuestosSinProcesarMes() {
  const [presupuestosTotal, setPresupuestosTotal] = useState([]);
  
  const actualizarTotales = () => {
    obtenerPresupuestosTotal().then((response) => {
      const Data = response.data;
      setPresupuestosTotal(Data);
    });
  };

  useEffect(() => {
    const ac = new AbortController();
    obtenerPresupuestosTotal().then((response) => {
      const Data = response.data;
      setPresupuestosTotal(Data);
    });
    return () => ac.abort();
  }, []);

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 0.5 }}>
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 1.5,
        mb: 2 
      }}>
        <Box sx={{
          width: 48,
          height: 48,
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, #ffa726 0%, #fb8c00 100%)',
          boxShadow: '0 4px 12px rgba(255, 152, 0, 0.3)'
        }}>
          <HourglassEmptyIcon sx={{ color: 'white', fontSize: 28 }} />
        </Box>
        <Box>
          <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', fontSize: '0.7rem' }}>
            GENERAL
          </Typography>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, fontSize: '0.95rem', lineHeight: 1.2 }}>
            Sin Cerrar
          </Typography>
        </Box>
      </Box>

      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', mb: 2 }}>
        <Typography 
          variant="h4" 
          sx={{ 
            fontWeight: 800, 
            color: 'warning.main',
            textAlign: 'left',
            fontSize: { xs: '1.75rem', sm: '2rem' }
          }}
        >
          <NumberFormat
            value={presupuestosTotal.total}
            displayType="text"
            thousandSeparator="."
           decimalSeparator=","
            decimalScale={0}
  fixedDecimalScale={false}
            prefix="₲ "
          />
        </Typography>
        <Typography variant="caption" sx={{ color: 'text.secondary', mt: 0.5 }}>
          Total presupuestos pendientes
        </Typography>
      </Box>

      <Button 
        variant="outlined" 
        color="warning"
        onClick={actualizarTotales}
        startIcon={<RefreshIcon />}
        size="small"
        sx={{ 
          borderRadius: 1.5,
          textTransform: 'none',
          fontWeight: 600,
          borderWidth: 2,
          '&:hover': {
            borderWidth: 2,
            backgroundColor: 'warning.light',
            color: 'white'
          }
        }}
      >
        Actualizar
      </Button>
    </Box>
  );
}
